<template>
<div>

<v-dialog max-width="500" v-model="dialogVisible" transition="v-fade-transition" :fullscreen="$vuetify.breakpoint.smAndDown" persistent :hide-overlay=false scrollable>
 <div :style="{height: dialogHeight}" class="dialog-container">

    <div class="dialog-header">
        <v-toolbar dark flat dense class="primary">
            <div style="position:absolute;top:20px;right:20px;text-align:right">
                <transition name="x-slow-fade">
                    <img v-show="primaryImage" :src="primaryImage" class="round" style="max-width:50px;">
                </transition>
                <transition name="x-slow-fade">
                    <img v-show="secondaryImage" :src="secondaryImage" class="round" style="max-width:50px;">
                </transition>
            </div>


            <v-toolbar-title class="white--text">{{title}}</v-toolbar-title>
        </v-toolbar>
    </div>

    <div class="dialog-body pa-3">

        <v-form v-model="valid" ref="form">

        <v-text-field @keyup.native="calculateNames" @blur="cleanNames" :rules="namesRules" v-model.trim="fullNames" ref="fullNames" label="First and Last Names" :hint="fullNamesHint"></v-text-field>
        <UniqueContactEnforcer ref="enforcer1" :contact="primaryContactName"/>
        <UniqueContactEnforcer ref="enforcer2" :contact="secondaryContactName"/>

    <!-- <div v-show="tenantKey !== '007' ">  -->
        <!-- For Aussie Morayfield hide contact details -->
        <v-row wrap style="margin-top:-4px">
            <v-col xs12 sm6 v-if="couple">
                <v-text-field v-model="primaryMobile" :label="primaryMobileLabel" prepend-icon="phone"></v-text-field>
            </v-col>
            <v-col v-else>
                <v-text-field v-model="primaryMobile" :label="primaryMobileLabel" prepend-icon="phone"></v-text-field>
            </v-col>

            <v-col xs12 sm6 v-if="couple">
                <v-text-field v-model="secondaryMobile" :label="secondaryMobileLabel" prepend-icon="phone"></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <EmailBox v-model="primaryEmail" icon="mail_outline" ref="primaryEmail" :label="primaryEmailLabel" />
            </v-col>
        </v-row>
        <v-row>
            <v-col v-if="secondaryFirstName">
                <EmailBox v-model="secondaryEmail" icon="mail_outline" ref="secondaryEmail" :label="secondaryEmailLabel" />
            </v-col>
        </v-row>
    <!-- </div> -->

        <v-text-field v-model="transactionName" :rules="requiredRules" label="Transaction Name" />

        <div style="display:flex">
            <v-select
            :items="transactionTemplates"
            v-model="masterKey"
            label="Template"
            item-value="meta.key"
            item-text="description"
            />
            <v-select style="margin-left:10px"
            :items="officesList"
            v-model="tenantKey"
            label="Office"
            item-value="meta.key"
            item-text="name"
            />

        </div>
        </v-form>
    </div>

    <div class="dialog-footer">
        <v-tooltip right>
            <template v-slot:activator="{ on }">
            <v-btn style="float:left;margin-right:8px" v-on="on" outlined icon @click.native.stop.prevent="clickedSave('Checklist')">
                <v-icon>mdi-format-list-checks</v-icon>
            </v-btn>
            </template>
            <span>Save and go to checklist</span>
        </v-tooltip>
        <v-tooltip right>
            <template v-slot:activator="{ on }">
            <v-btn style="float:left" v-on="on" outlined icon @click.native.stop.prevent="clickedSave('Transaction')">
                <v-icon>mdi-television-guide</v-icon>
            </v-btn>
            </template>
            <span>Save and go to transaction</span>
        </v-tooltip>

        <v-btn text @click.native="clickedCancel">Cancel</v-btn>
        <v-btn text @click.native="clickedSave">Save</v-btn>
    </div>

</div>

</v-dialog>

</div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import StringHelpers from '../helpers/StringHelpers'
import ContactHelpers from '../helpers/ContactHelpers'
import UserHelpers from '../helpers/UserHelpers'
import NiceData from '../data/NiceData'
import DataHelpers from '../helpers/DataHelpers'
import CloudHelpers from '../helpers/CloudHelpers'
import {format} from 'date-fns'
import DateHelpers, { dateFormats } from '../helpers/DateHelpers'
import UniqueContactEnforcer from '../ui-elements/UniqueContactEnforcer'
import EmailBox from '../ui-elements/EmailBox'
import ArrayHelpers from '../helpers/ArrayHelpers'
import Utilities from '../helpers/Utilities'
import AlertHelpers from '../helpers/AlertHelpers'
import LookupData from '../helpers/LookupData'

var db = firebase.database()


export default {
props:{
    visible: Boolean,
    data: Object
},
components: {
    UniqueContactEnforcer, EmailBox
},
data() {
    return {

        primaryEmailValidationErrors: '',
        secondaryEmailValidationErrors: '',

        namesRules: [
            v => (v.length > 2) || 'Valid names required',
            v => (v.indexOf(' ') > -1 && v.indexOf(' ') < v.length - 1) || 'Include both names'
        ],
        emailValidationRules: [
            v => !v || StringHelpers.isEmail(v) || 'Enter a valid email format',
        ],
        requiredRules: [
            v => (v && v.length > 2) || 'This field is required',
        ],

        valid: true,

        dialogVisible: this.visible,

        fullNames: '',
        fullNamesHint: 'eg. John and June Citizen',

        primaryFirstName: '',
        primaryLastName: '',
        primaryGender: '',
        primaryImage: '',
        secondaryFirstName: '',
        secondaryLastName: '',
        secondaryGender: '',
        secondaryImage: '',

        validNames: false,

        primaryMobile: '',
        primaryEmail: '',

        secondaryMobile: '',
        secondaryEmail: '',

        transactionName: '',
        masterKey: LookupData.getMasterKey(),   //todo: remove hardcoded default

        transactionTemplates: [],

        tenantKey: DataHelpers.getTenantKey(),

    }
},
computed: {


    defaultTransactionTemplateKey() {
        if(this.transactionTemplates.length < 1)
            return null
        let template = this.transactionTemplates.find(o => o.meta.key)
        if(template)
            return template.meta.key
        return this.transactionTemplates[0]

    },

    dialogHeight() {
        if(this.$vuetify.breakpoint.smAndDown)
            return '100%'
        else
            return '545px'
    },

    title () {
        if(this.marriedCouple)
            return 'Add Married Couple'
        else if(this.couple)
            return 'Add Couple'
        else
            return 'Add Client'
    },

    primaryMobileLabel () {
        if(this.primaryFirstName)
            return this.primaryFirstName + "'s Mobile"
        else
            return 'Primary Mobile'
    },

    primaryEmailLabel () {
        if(this.primaryFirstName)
            return this.primaryFirstName + "'s Email"
        else
            return 'Primary Email'
    },

    secondaryMobileLabel () {
        if(this.secondaryFirstName)
            return this.secondaryFirstName + "'s Mobile"
        else
            return 'Secondary Mobile'
    },

    secondaryEmailLabel () {
        if(this.secondaryFirstName)
            return this.secondaryFirstName + "'s Email"
        else
            return 'Secondary Email'
    },

    // validForm () {
    //     return this.validNames && this.transactionName.length > 2 && (this.tenantKey != null)
    // },

    individual() {
        return this.secondaryFirstName.length === 0
    },

    couple () {
        return this.secondaryFirstName.length > 1
    },

    marriedCouple () {
        return this.couple && (this.secondaryLastName == this.primaryLastName) && this.primaryLastName.length > 0
    },

    officesList() {
        return this.$store.getters.officesActive
    },

    primaryContactName() {
        return {
            firstName: this.primaryFirstName,
            lastName: this.primaryLastName,
        }
    },
    secondaryContactName() {
        return {
            firstName: this.secondaryFirstName,
            lastName: this.secondaryLastName,
        }
    }
},
methods: {

    checkForDemo() {
        if(this.fullNames != 'demo') return

        this.fullNames = 'Michael and Jessica Hampton'
        this.primaryMobile = '0413999951'
        this.primaryEmail = 'matt@ireland.mx'
        this.secondaryMobile = '0414012714'
        this.secondaryEmail = 'linda.a.ireland@gmail.com'
        this.transactionName = 'Purchase owner occ home'
    },
    getTenantsRef () {
        return db.ref('tenants/' + this.tenantKey)
    },
    calculateNames () {
        console.log('calcing names')
        this.checkForDemo()

        let fullNames = this.fullNames
        fullNames = fullNames.replace(' & ', ';').replace(/ and /gi, ';')
        let namesArr = fullNames.split(';')

        this.validNames = true

        let singleNameArr = namesArr[0].split(' ')
        this.primaryFirstName = StringHelpers.capitalizeFirstLetter(singleNameArr[0])

        if(singleNameArr.length > 1)
            this.primaryLastName = StringHelpers.capitalizeFirstLetter(singleNameArr[1])
        else
            this.primaryLastName = ''

        if(namesArr.length > 1) {
            //clientNames.count = 2
            singleNameArr = namesArr[1].split(' ')
            this.secondaryFirstName = StringHelpers.capitalizeFirstLetter(singleNameArr[0])

            if(singleNameArr.length > 1)
                this.secondaryLastName = StringHelpers.capitalizeFirstLetter(singleNameArr[1])
            else
                this.secondaryLastName = ''
        } else {
            this.secondaryFirstName = ''
            this.secondaryLastName = ''
        }

        if(this.primaryLastName == 'An'
            || this.primaryLastName == 'And'
            || this.primaryLastName.length < 2)
                this.primaryLastName = ''

        if(this.primaryLastName && this.secondaryFirstName && !this.secondaryLastName)
            this.secondaryLastName = this.primaryLastName

        if(this.secondaryLastName && !this.primaryLastName)
            this.primaryLastName = this.secondaryLastName

        if(this.primaryFirstName.length < 2 || this.primaryLastName < 2)
            this.validNames = false

        if(this.secondaryFirstName)
            if(this.secondaryFirstName.length < 2 || this.secondaryLastName.length < 2)
                this.validNames = false

    },

    cleanNames () {

        let fullNames
        if(this.marriedCouple)
            fullNames =  this.primaryFirstName + ' and ' + this.secondaryFirstName + ' ' + this.primaryLastName
        else if(this.couple)
            fullNames = this.primaryFirstName + ' ' + this.primaryLastName + ' and ' + this.secondaryFirstName + ' ' + this.secondaryLastName
        else
            fullNames = this.primaryFirstName + ' ' + this.primaryLastName

        this.fullNames  = fullNames

        let vm = this

        ContactHelpers.getGender(this.primaryFirstName).then(function(gender){
            vm.primaryGender = gender
            vm.primaryImage = ContactHelpers.getSampleImage(gender)
        })
        ContactHelpers.getGender(this.secondaryFirstName).then(function(gender){
            vm.secondaryGender = gender
            vm.secondaryImage = ContactHelpers.getSampleImage(gender)
        })
        this.$refs.enforcer1.check()
        this.$refs.enforcer2.check()
    },

    clickedSave (mode) {

        const secondaryEmailComponent = this.$refs.secondaryEmail
        const secondaryEmailValidationResult = secondaryEmailComponent ? secondaryEmailComponent.validate() : true

        if(!this.$refs.form.validate() || !this.$refs.primaryEmail.validate() || !secondaryEmailValidationResult)
            return

        let vm = this
        let secondaryClient
        let tenantRef = this.getTenantsRef()
        const couple = (this.secondaryFirstName.length > 1)
        const created = DateHelpers.todayString()
        const openedAt = DateHelpers.nowString()

        const primaryKey = db.ref().push().key
        const secondaryKey = db.ref().push().key
        const transactionKey = db.ref().push().key

        // Make client objects
        const me = this.$store.getters.user
        const owner = {

            key: me.uid || DataHelpers.getUserId(),
            firstName: me.firstName || '',
            lastName: me.lastName || ''
        }

        let primaryClient = {
            firstName: this.primaryFirstName,
            lastName: this.primaryLastName,
            mobile: this.primaryMobile,
            email: this.primaryEmail,
            created,
            gender: this.primaryGender,
            image: this.primaryImage,
            owner: owner,
            groups: {Client: true},
            openedAt: DateHelpers.nowString()
        }

        ContactHelpers.formatMobileForContact(primaryClient)

        if(couple) {
            secondaryClient = {
                firstName: this.secondaryFirstName,
                lastName: this.secondaryLastName,
                mobile: this.secondaryMobile,
                email: this.secondaryEmail,
                partner: {...primaryClient, key: primaryKey},
                created,
                gender: this.secondaryGender,
                image: this.secondaryImage,
                owner: owner,
                groups: {Client: true},
                openedAt: DateHelpers.nowString()

            }

            ContactHelpers.formatMobileForContact(secondaryClient)

            primaryClient.partner = {...secondaryClient, key: secondaryKey}
        }

        // Save Clients

        tenantRef.child('contacts').child(primaryKey).set(primaryClient)
        ContactHelpers.saveToAlgolia({...primaryClient, key: primaryKey, tenantKey: this.tenantKey})

        if(couple) {
            tenantRef.child('contacts').child(secondaryKey).set(secondaryClient)
            ContactHelpers.saveToAlgolia({...secondaryClient, key: secondaryKey, tenantKey: this.tenantKey})
        }

        // Transaction

        let transaction = {
            description: this.transactionName,
            created: format(new Date(), dateFormats.BACKWARDS),
            clients: this.fullNames,
            masterKey: this.masterKey
        }

        tenantRef.child('transactions').child(transactionKey).child('details').set(transaction)

        // Primary

        tenantRef.child('contactTransactions').child(primaryKey).child(transactionKey).set(transaction)
        delete primaryClient.partner
        //primaryClient.role = 'Client'

        //Old transaction way
        tenantRef.child('transactions').child(transactionKey).child('people').child(primaryKey).set(primaryClient)

        //New transaction way
        tenantRef.child('transactions').child(transactionKey).child('elements').child(primaryKey).set({
            type: 'Contact',
            name: 'client',
            tabKey: 'settings',
            transactionKey: transactionKey,
            role: 'Client',
            contactKey: primaryKey,
            contact:primaryClient,
            value: ContactHelpers.fullName(primaryClient)
        })

        //Secondary

        if(this.couple) {
            tenantRef.child('contactTransactions').child(secondaryKey).child(transactionKey).set(transaction)
            delete secondaryClient.partner
            //secondaryClient.role = 'Client'
            tenantRef.child('transactions').child(transactionKey).child('elements').child(secondaryKey).set({
                type: 'Contact',
                name: 'client',
                tabKey: 'settings',
                transactionKey: transactionKey,
                role: 'Client',
                contactKey: secondaryKey,
                contact:secondaryClient,
                value: ContactHelpers.fullName(secondaryClient)
            })
        }

        let result = {
            mode,
            transactionKey,
            tenantKey: this.tenantKey
        }

        this.$emit('save', result)
    },

    clickedCancel () {
        this.$emit('cancel')
    },

    initialiseDialog () {
        if(this.$refs.form)
            this.$refs.form.resetValidation()
        this.primaryEmailValidationErrors = ''
        this.secondaryEmailValidationErrors = ''
        this.fullNames = ''
        this.primaryFirstName = ''
        this.primaryLastName = ''
        this.primaryGender = ''
        this.primaryImage = ''

        this.secondaryFirstName = ''
        this.secondaryLastName = ''
        this.secondaryGender = ''
        this.secondaryImage = ''
        this.primaryMobile = ''
        this.primaryEmail = ''
        this.secondaryMobile = ''
        this.secondaryEmail = ''
        this.transactionName = ''
        let preferredOffice = DataHelpers.preferredOffice()
        this.tenantKey = preferredOffice.meta.key

        let ref = DataHelpers.getTenantRef(this.tenantKey).child('transactionTemplates')
        return NiceData.fetchItemsFromFirebase(ref).then(templates => {
            this.transactionTemplates = templates
            let defaultTransactionTemplate = this.transactionTemplates.find(template => template.isDefault)
            if(defaultTransactionTemplate && defaultTransactionTemplate.meta)
                this.masterKey = defaultTransactionTemplate.meta.key
        })
    },
},
watch: {
    'visible': function (newVal) {
        this.dialogVisible = newVal
        if(newVal) {
            this.initialiseDialog()
            Utilities.focus(this, 'fullNames')
        }

    },
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// AddClients.vue?48bd931a